import { COLUMN_TO_SORT_API_FIELD } from "./sortIcons.constant";

export function getSortApiField(column: string): string {
  return COLUMN_TO_SORT_API_FIELD[column] ?? column;
}
